export enum modalsActionTypes{
    SET_BUTTON_BLOCK = 'MODALS/SET_BUTTON_BLOCK',
    SET_INFO_MODAL = 'MODALS/SET_INFO_MODAL',
    SET_INFO_MODAL_MSG = 'MODALS/SET_INFO_MODAL_MSG',
    SET_WITHDRAW_MODAL = 'MODALS/SET_WITHDRAW_MODAL',
    SET_DEPOSIT_MODAL = 'MODALS/SET_DEPOSIT_MODAL',
    SET_TRANSACTION_MODAL = 'MODALS/SET_TRANSACTION_MODAL',
    SET_HISTORY_MODAL = 'MODALS/SET_HISTORY_MODAL',
    SET_PRICE_HISTORY_MODAL = 'MODALS/SET_PRICE_HISTORY_MODAL',
    SET_CHANGE_DEPOSIT_MODAL = 'MODALS/SET_CHANGE_DEPOSIT_MODAL',
    SET_REQUEST_TYPE = 'MODALS/SET_REQUEST_TYPE',
    SET_WARNING_REQUEST_MODAL = 'MODALS/SET_WARNING_REQUEST_MODAL',
    CLEAR_MODALS_STATE = 'MODALS/CLEAR_MODALS/STATE'
}

export type modals_actions_type = 
    set_button_block | 
    set_info_modal |
    set_info_modal_msg |
    set_withdraw_modal |
    set_deposit_modal |
    set_transaction_modal |
    set_history_modal |
    set_request_type | 
    set_change_deposit_modal |
    set_warning_request_modal |
    set_price_history_modal
;

interface set_price_history_modal {
    type: modalsActionTypes.SET_PRICE_HISTORY_MODAL,
    payload: boolean
}

interface set_warning_request_modal {
    type: modalsActionTypes.SET_WARNING_REQUEST_MODAL,
    payload: boolean
}

interface set_request_type {
    type: modalsActionTypes.SET_REQUEST_TYPE,
    payload: 'sell' | 'buy'
}

interface set_change_deposit_modal {
    type: modalsActionTypes.SET_CHANGE_DEPOSIT_MODAL,
    payload: boolean
}

interface set_button_block {
    type: modalsActionTypes.SET_BUTTON_BLOCK,
    payload: boolean
}

interface set_info_modal {
    type: modalsActionTypes.SET_INFO_MODAL,
    payload: boolean
}

interface set_info_modal_msg {
    type: modalsActionTypes.SET_INFO_MODAL_MSG,
    payload: string
}

interface set_withdraw_modal {
    type: modalsActionTypes.SET_WITHDRAW_MODAL,
    payload: boolean
}

interface set_deposit_modal {
    type: modalsActionTypes.SET_DEPOSIT_MODAL,
    payload: boolean
}

interface set_transaction_modal {
    type: modalsActionTypes.SET_TRANSACTION_MODAL,
    payload: boolean
}

interface set_history_modal {
    type: modalsActionTypes.SET_HISTORY_MODAL,
    payload: boolean
}
